import { RuleNum as Num } from "@/components/deck/RuleNum";
const STATS = ["Initial Charge", "Base DMG %", "ATK %", "ATK", "HP %", "HP", "DEF %", "DEF", "Crit Chance", "Crit DMG", "Attack Speed", "Charge Rate", "Evasion", "Accuracy"];

const Cutoffs = ({ cut, onChange, unit, prefix }) => (
  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", margin: "8px 0 16px" }}>
    {["Amazing", "Great", "Good"].map((g) => (
      <label key={g} style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center" }}>
        <b>{g}</b> {unit === "s" ? "≤" : "≥"} <Num value={cut[g]} onChange={(v) => onChange({ ...cut, [g]: v })} testid={`${prefix}-cut-${g}`} w={64} /> {unit}
      </label>
    ))}
    <span style={{ fontSize: 13, color: "var(--muted)" }}>Anything else is Below Good.</span>
  </div>
);

export const PvpRules = ({ rules, update }) => {
  const p = rules.pvp;
  const set = (patch) => update({ pvp: { ...p, ...patch } });
  return (
    <div data-testid="rules-pvp">
      <p style={{ fontSize: 13, marginBottom: 8 }}>Graded on <b>final Initial Charge</b>, measured as seconds above the hero's best reachable value ("Best IC" on the Heroes tab, 0s by default). The set bonus only counts when all 3 pieces are the same set.</p>
      <Cutoffs cut={p.cutoffs} onChange={(c) => set({ cutoffs: c })} unit="s" prefix="pvp" />
      <label style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
        Pantheon upgrade Initial Charge <Num value={p.pantheonIC} onChange={(v) => set({ pantheonIC: v })} testid="pvp-pantheon" w={64} /> s
      </label>
      <label style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center" }}>
        <input type="checkbox" checked={!!p.screenIncludesPantheon} onChange={(e) => set({ screenIncludesPantheon: e.target.checked })} data-testid="pvp-includes-pantheon" />
        The Ability screen already includes the Pantheon bonus (don't subtract it again)
      </label>
      <p className="lg-note" style={{ fontSize: 13, marginTop: 14 }}>Your exception rule: if a hero reaches its best Initial Charge even without a charge set (like Noble or Enchantress), the grade adds a note that a set boosting their ability would be better.</p>
    </div>
  );
};

export const PveRules = ({ rules, update }) => {
  const p = rules.pve, groups = rules.groups;
  const set = (patch) => update({ pve: { ...p, ...patch } });
  const setW = (g, stat, v) => update({ groups: { ...groups, [g]: { ...groups[g], weights: { ...groups[g].weights, [stat]: v } } } });
  return (
    <div data-testid="rules-pve">
      <p style={{ fontSize: 13, marginBottom: 8 }}>Each stat line on the 3 pieces earns its weight in points (main stats × the multiplier). A 3/3 set that suits the hero's group earns the set points. The score is the % of a perfect build for that group.</p>
      <Cutoffs cut={p.cutoffs} onChange={(c) => set({ cutoffs: c })} unit="%" prefix="pve" />
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 14, fontSize: 13 }}>
        <label>Main stat multiplier <Num value={p.mainMult} onChange={(v) => set({ mainMult: v })} testid="pve-mainmult" w={56} /></label>
        <label>Matching set points <Num value={p.setPoints} onChange={(v) => set({ setPoints: v })} testid="pve-setpoints" w={56} /></label>
      </div>
      <h4 className="serif" style={{ fontSize: 14, margin: "6px 0" }}>Stat weights by ability group (0 = useless, 3 = most important)</h4>
      <div className="lg-scroll">
        <table className="lg-itable">
          <thead><tr><th>Group</th>{STATS.map((s) => <th key={s}>{s}</th>)}</tr></thead>
          <tbody>{Object.entries(groups).map(([k, g]) => (
            <tr key={k} data-testid={`pve-group-${k}`}>
              <td className="lg-nm">{g.label}</td>
              {STATS.map((s) => <td key={s}><Num value={g.weights[s] ?? 0} onChange={(v) => setW(k, s, v)} testid={`pve-w-${k}-${s}`} w={46} /></td>)}
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
